import React from 'react';
import { Icon } from './Icon.js';
export const IconPriorityLow = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M8.00002 13L12 17L16 13", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M1.00003 11L11 1.00003L12 1.00003L13 1.00003L23 11L23 12L23 13L13 23L12 23L11 23L1.00002 13L1.00001 12L1.00003 11Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconPriorityLow.js.map